import { createFileRoute, useNavigate } from '@tanstack/react-router'
import * as v from 'valibot'
import { trpc } from '@/main'
import { Test } from '@/routes/_app/-components/applicants/test'
import { TestStepPending } from '@/routes/_app/-components/shared/flow-pending'

export const Route = createFileRoute('/_app/test/values')({
  validateSearch: v.object({
    retake: v.optional(v.boolean(), false),
    resume: v.optional(v.boolean()),
    // Carried through onboarding so the final landing can return to the visitor's intended destination.
    redirect: v.optional(v.string()),
  }),
  loaderDeps: ({ search }) => ({ retake: search.retake }),
  loader: ({ context, deps }) => {
    context.queryClient.prefetchQuery(
      trpc.applicants.getQuestions.queryOptions({ type: 'values', newTest: deps.retake }),
    )
  },
  component: RouteComponent,
  pendingComponent: TestStepPending,
})

function RouteComponent() {
  const navigate = useNavigate()
  const { retake, redirect } = Route.useSearch()
  // Logged-out → /login is enforced centrally by the `_app` layout guard (see route-access).
  return (
    <Test
      type="values"
      nextStep={() => navigate({ to: '/test/personality', search: { redirect }, viewTransition: true })}
      previousStep={() => navigate({ to: '/test/competences', search: { redirect }, viewTransition: true })}
      newTest={retake}
    />
  )
}
